import React from 'react'
import { APILoggerDetail } from '../../models/APILoggerDetail';
import RangeSelector, {
    Size, Chart as ChartOptions, Margin, Scale, Behavior, RangeSelectorTypes, ValueAxis as RangeAxis
} from 'devextreme-react/range-selector';
import Legend from 'devextreme-react/chart';

interface Readings extends Record<string, any> {
    date: Date;

}

interface Props {
    graphData: Array<Readings>
    updateVisualRange: (e: RangeSelectorTypes.ValueChangedEvent) => void
    visualRange: {
        startValue?: any;
        endValue?: any;
    };
    loggers: Array<APILoggerDetail>
    renderRangeFinderSeries: (logger: APILoggerDetail) => void
}
const GraphRangeSelector: React.FC<Props> = ({ graphData, updateVisualRange, visualRange, loggers, renderRangeFinderSeries }) => {

    return <RangeSelector
        dataSource={graphData}
        onValueChanged={updateVisualRange}
        style={{ background: "#ffffff", margin: "10px", padding: "10px" }}
        value={{ startValue: visualRange.startValue, endValue: visualRange.endValue} }
    >
        <Behavior valueChangeMode="onHandleMove" />
        <Size height={150} />
        <Scale
            startValue={visualRange.startValue}
            endValue={visualRange.endValue}
        />
        <ChartOptions>
            <Legend visible={false} />
            {loggers.map((logger) => {
                return renderRangeFinderSeries(logger)
            }
            )}

        </ChartOptions>
    </RangeSelector>
}
export default GraphRangeSelector